
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionLinkGrid extends Serenity.EntityGrid<ExceptionLinkRow, any> {
        protected getColumnsKey() { return 'Exceptions.ExceptionLink'; }
        protected getDialogType() { return ExceptionLinkDialog; }
        protected getIdProperty() { return ExceptionLinkRow.idProperty; }
        protected getInsertPermission() { return ExceptionLinkRow.insertPermission; }
        protected getLocalTextPrefix() { return ExceptionLinkRow.localTextPrefix; }
        protected getService() { return ExceptionLinkService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}